import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('pulse');
